import React from 'react';
import './VirtualCard.css';

const VirtualCard = ({ card, sortCode, accountNumber }) => {
  return (
    <div className="virtual-card-container">
      <div className="virtual-card shadow-lg">
        <div className="virtual-card-mask">
          <div className="card-top">
            <div className="card-logo"></div>
          </div>
          <div className="card-chip"></div>
          <div className="card-number">
            {card.cardNumber.replace(/\d{4}(?=.)/g, '$& ')}
          </div>
          <div className="card-4-digits">{card.cvc}</div>
          <div className="card-expiry">
            <label>Expires<br />End</label>
            <div>{card.expiryDate.substring(0, 2)}/{card.expiryDate.substring(2, 4)}</div>
          </div>
          <div className="card-bottom">
            <div className="card-info">
              <div className="card-holder">
                <div style={{ fontSize: 14 }}>{card.cardHolderName?.toUpperCase()}</div>
                <div style={{ fontSize: 12 }}>{sortCode}&nbsp;{accountNumber}</div>
              </div>
            </div>
            <div className="visa-logo"></div>
          </div>
        </div>
        <div className="card-currency">{card.currency}</div>
      </div>
    </div>
  );
};

export default VirtualCard;
